import {Trans} from '@lingui/macro';
import {isUndefined} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../../../../libs/shared/ui/src/styles/paletteModel';
import {
  RelativeDateTimeFormatsEnum,
  RelativeDateTimeFormatter,
} from '../../../../../../srcCommon/formatters/dateTime/relativeDateTimeFormatter';
import {StaticViewerBanner} from '../static/staticViewerBanner';

/*
 * Props.
 */

interface LastSyncedActivityProps {
  lastSyncedDate: number | undefined;
}

/*
 * Style.
 */

const StyledStaticViewerSpan = styled.span`
  color: ${(p) => p.theme.greys.shade90};
`;

const StyledTitleDiv = styled.div`
  display: inline-block;
  font-weight: ${fontWeights.bold};
`;

/*
 * Component.
 */

export const LastSyncedActivity: FC<LastSyncedActivityProps> = (props) => {
  if (isUndefined(props.lastSyncedDate)) {
    return null;
  }

  return (
    <StaticViewerBanner iconName="offlineFilledSmall" color={PaletteColorsEnum.BLUE}>
      <StyledStaticViewerSpan>
        <StyledTitleDiv>
          <Trans id="activity-lastsynced-title">Synced</Trans>
        </StyledTitleDiv>{' '}
        {renderLastSyncedDate(props.lastSyncedDate)}
      </StyledStaticViewerSpan>
    </StaticViewerBanner>
  );
};

function renderLastSyncedDate(lastSyncedDate: number) {
  if (isUnderAMinuteAgo(lastSyncedDate)) {
    return <Trans id="activity-lastsynced-now">Now</Trans>;
  }

  const relativeSeenAtTime = (
    <RelativeDateTimeFormatter value={lastSyncedDate} format={RelativeDateTimeFormatsEnum.LONG} />
  );
  return <Trans id="activity-lastsynced-timeago">{relativeSeenAtTime} ago</Trans>;
}

function isUnderAMinuteAgo(lastSyncedDate: number) {
  return Date.now() - lastSyncedDate < 60 * 1000;
}
